import React from "react";

import { UseFormReturn } from "react-hook-form";

import {
    Box,
    Button,
    Typography
} from "@mui/material";

import {
    t,
    Trans
} from "@lingui/macro";

import {
    ZPlayLoader,
    NavigationBack
} from "commons";

import { ManageAwardState } from "./models";
import { DefaultTypedResponse } from "models/response";
import { Award } from "models";

import { ContentProducerService } from "services/content-producer-service";
import AddIcon from "@mui/icons-material/Add";
import { withSnackbar, WithSnackbarProps } from "notistack";
import { AwardTable, CreateAndEditAwardModal } from "components/backoffice/award";

class ManageAward extends React.Component<UseFormReturn & WithSnackbarProps, ManageAwardState>{

    constructor(props: any) {
        super(props);

        this.state = {
            searchFilter: null,
            pagination: { pageSize: 20, pageIndex: 0 },
            awardCount: 0,
            awardList: [],
            data: null,
            isLoading: true,
            openEditAwardModal: false,
            openCreateAwardModal: false,
            editAward: null
        };
    }

    public componentDidMount() {
        this.getPaginatedAwardWithStateParameters()
    };

    private paginationUpdated = (pagination: any) => {

        ////****
        // VERY IMPORTANTE! Mongoose Paginate prende di default come prima pagina la pagina 1, mentre la tabella la pagina 0. Serve questo piccolo workaround
        ////****

        this.setState(() => ({
            isLoading: true,
            pagination: pagination
        }), () => ContentProducerService.getAwardListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getAwardCallback, this.getAwardErrorCallback));

    }

    private getPaginatedAwardWithStateParameters = () => {

        this.setState(() => ({
            isLoading: true,
        }));

        ContentProducerService.getAwardListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getAwardCallback, this.getAwardErrorCallback);
    }

    private deleteAward = (id: string): void => {

        this.setState(() => ({
            isLoading: true,
        }));

        if ((this.state.awardList.length - 1) % this.state.pagination.pageSize === 0 && this.state.pagination.pageIndex !== 0) {
            this.setState((prevState) => ({
                pagination: {
                    ...prevState.pagination,
                    pageIndex: this.state.pagination.pageIndex - 1
                }
            }));
        }

        ContentProducerService.deleteAward(id, this.getPaginatedAwardWithStateParameters, this.deleteAwardErrorCallback);
    }

    private getAwardCallback = (data: DefaultTypedResponse<Award>): void => {

        this.setState(() => ({
            awardCount: data.size,
            awardList: data.list,
            isLoading: false,
        }));
    };

    private editAwardCallback = (): void => {
        this.setState(() => ({ openEditAwardModal: false }));
        this.getPaginatedAwardWithStateParameters();
    };

    private createAwardCallback = (): void => {
        this.setState(() => ({ openCreateAwardModal: false }));
        this.getPaginatedAwardWithStateParameters();
    };

    private deleteAwardErrorCallback = (err: any): void => {
        this.setState(() => ({
            isLoading: false
        }));

        this.props.enqueueSnackbar(t({
            id: "ma-error-delete-award",
            message: "Si è verificato un errore. L'award non è stato eliminato"
        }), {
            variant: "error",
        });
    }

    private getAwardErrorCallback = (err: any): void => {
        this.setState(() => ({
            isLoading: false
        }));


        this.props.enqueueSnackbar(t({
            id: "ma-error-get-award",
            message: "Si è verificato un errore."
        }), {
            variant: "error",
        });
    };

    private editAwardErrorCallback = (err: any): void => {
        this.setState(() => ({
            openEditAwardModal: false
        }));

        this.props.enqueueSnackbar(t({
            id: "ma-error-edit-award",
            message: "Si è verificato un errore. L'award non è stato modificato"
        }), {
            variant: "error",
        });
    };

    private creatAwardErrorCallback = (err: any): void => {
        this.setState(() => ({
            openCreateAwardModal: false
        }));

        this.props.enqueueSnackbar(t({
            id: "ma-error-create-award",
            message: "Si è verificato un errore. L'award non è stato creato"
        }), {
            variant: "error",
        });
    };


    private openEditAwardModal = (award: Award): void => {
        this.setState(() => ({
            openEditAwardModal: true,
            editAward: award
        })
        )
    }

    private closeModal = (): void => {
        this.setState(() => ({
            openEditAwardModal: false,
            editAward: null,
            openCreateAwardModal: false
        }));
    };

    private openCreateAwardModal = (): void => {
        this.setState(() => ({
            openCreateAwardModal: true,
        })
        )
    }

    render() {
        return (
            <Box sx={{ textAlign: "center", p: 5 }}>
                <NavigationBack/>
                <Typography variant="h2" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                    <Trans id="ma-text-title">Premi e riconoscimenti</Trans>
                </Typography>
                <Box sx={{ textAlign: "right", pr: 2 }}>
                    <Button
                        endIcon={<AddIcon />}
                        onClick={this.openCreateAwardModal}
                        variant={"contained"}
                    >
                        <Trans id="ma-button-add">Aggiungi</Trans>
                    </Button>
                </Box>
                {<Box sx={{ p: 2, mt: 2 }}>
                    <AwardTable
                        pagination={this.state.pagination}
                        awards={this.state.awardList}
                        totalAwardCount={this.state.awardCount}
                        deleteAward={this.deleteAward}
                        openEditAwardTable={this.openEditAwardModal}
                        updatePaginationCallBackFn={this.paginationUpdated}
                    />
                </Box>}
                {this.state.openEditAwardModal && <CreateAndEditAwardModal
                    closeModal={this.closeModal}
                    editAwardCallback={this.editAwardCallback}
                    editAwardErrorCallback={this.editAwardErrorCallback}
                    award={this.state.editAward}
                />}
                {this.state.openCreateAwardModal && <CreateAndEditAwardModal
                    closeModal={this.closeModal}
                    createAwardCallback={this.createAwardCallback}
                    createAwardErrorCallback={this.creatAwardErrorCallback}
                />}
                {this.state.isLoading && <ZPlayLoader />}
            </Box>);
    }
}

export default withSnackbar(ManageAward);